import { useSelector } from 'react-redux';
import { getPage } from '../redux/selectors/page';
import useGruser from './useGruser';
export const usePage = ()=>{
    const { gruser } = useGruser();
    return useSelector((state)=>getPage(state, gruser));
};
export default usePage;
